import { useEffect, useState, useRef } from 'react';
import Navbar from '../Components/NavBarV2';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';
import { db, storage, auth } from '../Firebase/Firebase';
import { getDocs, collection, setDoc, doc, query, where, updateDoc, deleteDoc, getDoc } from 'firebase/firestore';
import './spaceDetails.css'
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { listAll } from 'firebase/storage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SpaceDetails = () => {
    const [location, setLocation] = useState(null);
    const [accesorios, setAccesorios] = useState("");
    const [capacidadMax, setCapacidadMax] = useState("");
    const [capacidadMin, setCapacidadMin] = useState("");
    const [color, setColor] = useState("#fcbf49");
    const [descripcionEspacio, setDescripcionEspacio] = useState("");
    const [idLugar, setIdLugar] = useState("");
    const [nombreEspacio, setNombreEspacio] = useState("");
    const [tipoEspacio, setTipoEspacio] = useState("");
    const [idTipoEspacio, setIdTipoEspacio] = useState('');
    const [descripcionTipo, setDescripcionTipo] = useState('');
    const [tiposEspacio, setTiposEspacio] = useState([]);
    const [espacios, setEspacios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [logo, setlogo] = useState(null);
    const fetchEspacios = async () => {
        if (idLugar) {
            const espaciosCollection = collection(db, 'espacios');
            const q = query(espaciosCollection, where('IdLugar', '==', idLugar));
            const querySnapshot = await getDocs(q);

            const espaciosData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));
            setEspacios(espaciosData);
            console.log("Espacios después de la consulta:", espaciosData); // Cambiado a 'espaciosData'

        }
        setLoading(false);
    };
    useEffect(() => {
        fetchEspacios();
    }, [idLugar]);
    // Función para obtener los tipos de espacio desde Firestore
    const fetchTiposEspacio = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, 'tipoespacio'));
            const tipos = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                tipos.push({
                    id: doc.id, // Usamos el ID del documento
                    tipoEspacio: data.TipoEspacio,
                    descripcionEspacio: data.DescripcionEspacio
                });
            });
            setTiposEspacio(tipos);
        } catch (error) {
            console.error("Error al obtener los tipos de espacio:", error);
        }
    };

    // useEffect para ejecutar la consulta al cargar el componente
    useEffect(() => {
        fetchTiposEspacio();
    }, []);
    // Función para generar un ID aleatorio para el espacio
    const generateRandomId = () => {
        return 'espacio_' + Math.random().toString(36).substr(2, 9);
    };

    const [imagenesEspacio, setImagenesEspacio] = useState([]);
    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        agregarImagenes(files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const agregarImagenes = (nuevas) => {
        const unicas = nuevas.filter(
            (file) => !imagenesEspacio.some(img => img.name === file.name && img.size === file.size)
        );
        setImagenesEspacio(prev => [...prev, ...unicas]);
    };

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        agregarImagenes(files);
    };

    const eliminarImagen = (index) => {
        const nuevas = [...imagenesEspacio];
        nuevas.splice(index, 1);
        setImagenesEspacio(nuevas);
    };



    const imageInputRef = useRef(null); // Referencia para el campo de imágenes
    const iconInputRef = useRef(null);  // Referencia para el campo de ícono

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!idLugar) {
            toast.error("El id del Lugar no está disponible. Asegúrate de que está almacenado correctamente.");
            return;
        }

        if (!idTipoEspacio) {
            toast.error("Por favor selecciona un tipo de espacio.");
            return;
        }

        const newIdEspacio = generateRandomId();
        const imageUrls = [];  // Lista para almacenar los URLs de las imágenes
        let logoUrl = null;

        try {
            // Subir cada imagen a Firebase Storage
            for (let i = 0; i < imagenesEspacio.length; i++) {
                const imagen = imagenesEspacio[i];
                const imageName = `${newIdEspacio}${i + 1}.png`;
                const storageRef = ref(storage, `FotosEspacio/${newIdEspacio}/${imageName}`);
                const snapshot = await uploadBytes(storageRef, imagen);
                const downloadURL = await getDownloadURL(snapshot.ref);
                imageUrls.push(downloadURL);
            }

            // Subir el logo si se ha seleccionado


            // Crear el objeto de datos del nuevo espacio
            const newData = {
                IdEspacio: newIdEspacio,
                Accesorios: accesorios,
                CapacidadMax: Number(capacidadMax),
                CapacidadMin: Number(capacidadMin),
                Color: color,
                DescripcionEspacio: descripcionEspacio,
                IdLugar: idLugar,
                NombreEspacio: nombreEspacio,
                TipoEspacio: idTipoEspacio,
                Imagenes: imageUrls,
                logo: logoUrl
            };

            // Registrar el espacio en Firestore
            await setDoc(doc(db, "espacios", newIdEspacio), newData);
            fetchEspacios();

            limpiarCamposFormulario();
            // Reinicia el valor de los campos de archivo después de registrar
            if (imageInputRef.current) imageInputRef.current.value = "";
            if (iconInputRef.current) iconInputRef.current.value = "";
            toast.success("Registro Exitoso");

        } catch (error) {
            console.error("Error al registrar el espacio: ", error);
            toast.error("Error al registrar el espacio. Por favor intenta de nuevo.");
        }
    };


    // Función para manejar el cambio de selección del tipo de espacio
    const handleTipoEspacioChange = (e) => {
        const selectedTipoEspacio = e.target.value;
        setTipoEspacio(selectedTipoEspacio);

        // Encontrar el tipo de espacio seleccionado y obtener su id y descripción
        const selectedEspacio = tiposEspacio.find(tipo => tipo.tipoEspacio === selectedTipoEspacio);
        if (selectedEspacio) {
            setIdTipoEspacio(selectedEspacio.id);  // Guardar el idTipoEspacio
            setDescripcionTipo(selectedEspacio.descripcionEspacio);  // Mostrar la descripción del espacio
        } else {
            setIdTipoEspacio('');
            setDescripcionTipo('');
        }
    };


    const [selectedEspacio, setSelectedEspacio] = useState(null);
    const [modalIsOpenUpdate, setModalIsOpenUpdate] = useState(false);
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);

    const handleMarkerClick = (espacio) => {
        setSelectedEspacio({
            IdEspacio: espacio.IdEspacio, // Usamos mayúscula para coincidir con los nombres consistentes
            NombreEspacio: espacio.NombreEspacio,
            TipoEspacio: espacio.TipoEspacio,  // Asegurando la consistencia en los nombres de propiedades
            CapacidadMax: espacio.CapacidadMax,
            CapacidadMin: espacio.CapacidadMin,
            DescripcionEspacio: espacio.DescripcionEspacio,
            Accesorios: espacio.Accesorios,
            Color: espacio.Color,
            Imagenes: espacio.Imagenes || [],  // Asegúrate de incluir las imágenes, o un array vacío si no hay
            logo: espacio.logo,
        });
        setModalIsOpenUpdate(true); // Abre el modal de edición
    };


    const closeModalUpdate = () => {
        setModalIsOpenUpdate(false);
    };

    const closeDeleteModal = () => {
        setDeleteModalIsOpen(false);
    };


    const handleEditEspacio = async (e) => {
        e.preventDefault();

        // Extraer los valores del objeto selectedEspacio
        const { IdEspacio, NombreEspacio, TipoEspacio, CapacidadMax, CapacidadMin, DescripcionEspacio, Accesorios, Color, Imagenes, logo } = selectedEspacio;

        if (!NombreEspacio || !TipoEspacio || !CapacidadMax || !CapacidadMin || !DescripcionEspacio || !Accesorios || !Color) {
            toast.error("Faltan valores: Todos los campos deben estar definidos.");
            return;
        }

        try {
            const docRef = doc(db, "espacios", IdEspacio);

            // 1. Eliminar imágenes anteriores de Firebase Storage si hay nuevas imágenes
            let updatedImageUrls = [...Imagenes];
            if (imagenesEspacio && imagenesEspacio.length > 0) {
                for (const imageUrl of Imagenes) {
                    const imageRef = ref(storage, imageUrl);
                    await deleteObject(imageRef).catch((error) => {
                        console.warn(`Error al eliminar la imagen ${imageUrl}:`, error);
                    });
                }

                // 2. Subir las nuevas imágenes
                const newImageUrls = await uploadImages(imagenesEspacio, IdEspacio);
                updatedImageUrls = [...newImageUrls];
            }

            // Manejar la actualización del logo si se selecciona uno nuevo
            let logoUrl = logo; // Usa el logo existente como valor inicial


            // 4. Actualizar los datos en Firestore
            await updateDoc(docRef, {
                NombreEspacio,
                TipoEspacio,
                CapacidadMax,
                CapacidadMin,
                DescripcionEspacio,
                Accesorios,
                Color,
                Imagenes: updatedImageUrls, // Actualizar las imágenes
                Logo: logoUrl,             // Actualizar el logo
            });

            setModalIsOpenUpdate(false); // Cerrar el modal después de la actualización
            fetchEspacios(); // Recargar la lista de espacios
            toast.success("Documento actualizado correctamente");

        } catch (error) {
            toast.error("Error actualizando el espacio");

            console.error("Error actualizando el espacio:", error);
        }
    };


    // Función para limpiar campos del formulario después de guardar o actualizar
    const limpiarCamposFormulario = () => {
        setAccesorios('');
        setCapacidadMax('');
        setCapacidadMin('');
        setColor('');
        setDescripcionEspacio('');
        setNombreEspacio('');
        setTipoEspacio('');
        setIdTipoEspacio('');
        setDescripcionTipo('');
        setImagenesEspacio([]);
        setlogo(null);
    };


    const uploadImages = async (images, existingIdEspacio) => {
        const urls = [];

        for (let i = 0; i < images.length; i++) {
            const imagen = images[i];
            const imageName = `${existingIdEspacio}${i + 1}`; // Usa el Id existente para nombrar la imagen

            // Ruta de almacenamiento: FotosEspacio/{existingIdEspacio}/Id{i+1}
            const storageRef = ref(storage, `FotosEspacio/${existingIdEspacio}/${imageName}`);
            const snapshot = await uploadBytes(storageRef, imagen);
            const downloadURL = await getDownloadURL(snapshot.ref);
            urls.push(downloadURL);  // Agregar cada URL a la lista
        }

        return urls; // Devuelve las URLs de las imágenes subidas
    };




    // Función para abrir el modal de verificación de eliminación
    const openDeleteModal = (espacio) => {
        setSelectedEspacio({
            IdEspacio: espacio.IdEspacio, // Usamos mayúscula para coincidir con los nombres consistentes
            NombreEspacio: espacio.NombreEspacio,
            TipoEspacio: espacio.TipoEspacio,  // Asegurando la consistencia en los nombres de propiedades
            CapacidadMax: espacio.CapacidadMax,
            CapacidadMin: espacio.CapacidadMin,
            DescripcionEspacio: espacio.DescripcionEspacio,
            Accesorios: espacio.Accesorios,
            Color: espacio.Color,
        });
        setDeleteModalIsOpen(true);
    };


    // Función para eliminar el espacio y la carpeta de imágenes
    const handleDeleteEspacio = async () => {
        try {
            const docRef = doc(db, "espacios", selectedEspacio.IdEspacio);

            // Primero, obtén el documento para acceder a las URLs de las imágenes
            const docSnapshot = await getDoc(docRef);
            if (docSnapshot.exists()) {
                // Construir la referencia a la carpeta que deseas eliminar
                const folderRef = ref(storage, `FotosEspacio/${selectedEspacio.IdEspacio}`);

                // Listar todos los archivos en la carpeta
                const listResult = await listAll(folderRef);

                // Crear promesas para eliminar cada archivo
                const deletePromises = listResult.items.map(item => deleteObject(item));

                // Esperar a que se completen todas las eliminaciones
                await Promise.all(deletePromises);
            }

            // Ahora elimina el documento de Firestore
            await deleteDoc(docRef);
            setDeleteModalIsOpen(false); // Cerrar el modal de verificación
            fetchEspacios(); // Asegúrate de que esta función esté definida para volver a cargar los espacios
            toast.success("Espacio y su carpeta de imágenes eliminados correctamente");

        } catch (error) {
            toast.error("Error eliminando el espacio.");

            console.error("Error eliminando el espacio:", error);
        }
    };



    return (
        <div>
            <Navbar />
            <ToastContainer />

            <div className='details-titulo'>
                {location ? (
                    <div>
                        <p><strong>Registrar Espacio del Lugar:</strong> {location.nombreLugar}</p>
                    </div>
                ) : (
                    <p>Cargando detalles...</p>
                )}
            </div>
            <div className='center-header-space'>
                <img className='imagenlateral1' src={Lateral1} alt="Lateral" />
                <div className="Presentation">
                    <div className="form-container-space">
                        <form onSubmit={handleSubmit}>
                            <div className="form-row">

                                <div className="form-column">
                                    <p>Nombre del Espacio:</p>
                                    <input
                                        type="text"
                                        value={nombreEspacio}
                                        onChange={(e) => setNombreEspacio(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-column">
                                    <p>Descripción del Espacio:</p>
                                    <textarea
                                        value={descripcionEspacio}
                                        onChange={(e) => setDescripcionEspacio(e.target.value)}
                                        required
                                    ></textarea>
                                </div>
                                <div className="form-column">
                                    <p>Tipo de Espacio:</p>
                                    <select
                                        value={tipoEspacio}
                                        onChange={handleTipoEspacioChange}
                                        required
                                    >
                                        <option value="">Selecciona un tipo de espacio</option>
                                        {tiposEspacio.map((tipo) => (
                                            <option key={tipo.id} value={tipo.tipoEspacio}>
                                                {tipo.tipoEspacio}
                                            </option>
                                        ))}
                                    </select>
                                </div>


                                <div className="form-column">
                                    <p>Capacidad Mínima:</p>
                                    <input
                                        type="number"
                                        value={capacidadMin}
                                        onChange={(e) => setCapacidadMin(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-column">
                                    <p>Capacidad Máxima:</p>
                                    <input
                                        type="number"
                                        value={capacidadMax}
                                        onChange={(e) => setCapacidadMax(e.target.value)}
                                        required
                                    />
                                </div>


                            </div>

                            <div className="form-row">

                                <div className="form-column">
                                    <p>Accesorios:</p>
                                    <textarea
                                        type="text"
                                        value={accesorios}
                                        onChange={(e) => setAccesorios(e.target.value)}
                                        required
                                    ></textarea>
                                </div>
                                <div className="form-column">
                                    <p>Color:</p>
                                    <input
                                        type="color"
                                        value={color}
                                        onChange={(e) => setColor(e.target.value)}
                                        required
                                        style={{ backgroundColor: color }}  // Cambia el fondo al color seleccionado
                                    />
                                </div>

                            </div>
                            <div className="form-row">

                                <div className="form-column">
                                    <p>Imágenes del espacio:</p>

                                    <div
                                        className="drop-zone"
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                    >
                                        <p>Arrastra y suelta imágenes aquí o haz clic para subir</p>
                                        <input
                                            type="file"
                                            multiple
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            ref={imageInputRef}
                                        />
                                    </div>

                                    {imagenesEspacio.length > 0 && (
                                        <div className="image-preview-grid">
                                            {imagenesEspacio.map((img, index) => (
                                                <div key={index} className="preview-item">
                                                    <img src={URL.createObjectURL(img)} alt={`img-${index}`} />
                                                    <button onClick={() => eliminarImagen(index)} className="delete-btn">✕</button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>


                            </div>
                            <button className='btn-space-details' type="submit">Registrar Espacio</button>

                        </form>
                    </div>
                </div>
                <img className='imagenlateral2' src={Lateral2} alt="Lateral" />
            </div>
            <div>

            </div>

        </div>

    );
};

export default SpaceDetails;
